export default [
    {
      position: "absolute",
      top: 3.4,
      left: 0.8,
      class: "tooltips",
      animation: "pulsing",
      isTooltip: true,
      navPos: 7,
      tooltipText: "vacanciesP3.back",
      tooltipClass: "right",
      hover: false,
      id: "HR_Homepage_Navigation_Recruit",
      index: 0,
    },
    {
        position: "absolute",
        top: 25,
        left: 90.5,
        class: "video",
        animation: "pulsing",
        modalClass: "modal-top-right",
        isDialog: true,
        modal: false,
        mTitle: "vacanciesP3.aiMatchingTitle",
        mBody: "vacanciesP3.aiMatchingBody",
        isVideo: true,
        videoThumb: "HR-Ai-Matching-Thumb",
        videoURL: "HR-Ai-Matching.mp4",
        vidIcon: true,
        id: "HR_Homepage_Video_PersonalizedHomepage",
        index: 1,
      },
      {
        position: "absolute",
        top: 33,
        left: 35,
        class: "dialog",
        animation: "pulsing",
        modalClass: "modal-top-left",
        isDialog: true,
        modal: false,
        mTitle: "vacanciesP3.candidateLonglistTitle",
        mBody: "vacanciesP3.candidateLonglistBody",
        id: "HR_Homepage_Info_TailoredDashboards",
        infoIcon: true,
        isAction: false,
        index: 2,
      },
      {
        position: "absolute",
        top: 51.8,
        left: 19,
        class: "dialog",
        animation: "pulsing",
        modalClass: "modal-top-left",
        isDialog: true,
        modal: false,
        mTitle: "vacanciesP3.applicantDetailsTitle",
        mBody: "vacanciesP3.applicantDetailsBody",
        id: "HR_Homepage_Info_TailoredDashboards",
        infoIcon: true,
        isAction: false,
        index: 3,
      },
  ];